import BillzTypographyHelptext from 'components/BillzTypographies/BillzTypographyHelptext';
import React from 'react';
import { getNameForPeriod } from 'utility/invoicePeriods';

export const PeriodicInvoiceDescriptor = ({ isPeriodicInvoice, issuingPeriod }) => {
    return (
        isPeriodicInvoice === true ? <BillzTypographyHelptext>Okresowa/{getNameForPeriod(issuingPeriod)}</BillzTypographyHelptext> : <React.Fragment />
    );
  };